var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField } from "formik";
import React from "react";
import { Checkbox } from "../../Selectable";
import { FormikField } from "../fieldHelpers";
export const FormikCheckboxInput = (_a) => {
    var { name, label, description } = _a, props = __rest(_a, ["name", "label", "description"]);
    const [field, , { setValue }] = useField(name);
    const value = field.value;
    return (React.createElement(FormikField, Object.assign({}, Object.assign({ name }, props)),
        React.createElement(Checkbox, Object.assign({}, { label, description, value }, { onChange: (v) => setValue(v) }))));
};
//# sourceMappingURL=FormikCheckboxInput.js.map